import { withNamespaces } from "react-i18next";
import { Col, Row } from "reactstrap";
import OverviewHeader from "src/modules/data-protection/pages/admin/software/overview-header";
import useSoftwareOverview from "./hooks/useSoftwareOverview";
import AiSummary from "./components/ai-summary";
import OverviewApprovals from "./components/approvals";
import DocumentationChangeTrend from "./components/documentation-change-trend";
import DocumentationGap from "./components/documentation-gap";
import NextSteps from "./components/next-steps";
import DataFlowCard from "./components/data-flow";
import RisksCreatedChart from "./components/risks-created";
import RecentActivity from "./components/recent-activity";

import "./style.scss";

const OverviewSkeleton = () => (
    <div className="p-4 overview-content">
        <div
            className="dt-field dt-skeleton mb-4"
            style={{ width: "100%", height: "88px" }}
        />
        <div
            className="dt-field dt-skeleton mb-4"
            style={{ width: "100%", height: "320px" }}
        />
        <div
            className="dt-field dt-skeleton"
            style={{ width: "100%", height: "160px" }}
        />
    </div>
);

const Overview = ({ t, softwareData }) => {
    const overviewQuery = useSoftwareOverview({
        softwareId: softwareData.id,
        t
    });

    if (overviewQuery.isLoading) {
        return <OverviewSkeleton />;
    }

    if (overviewQuery.isError || !overviewQuery.data) {
        return (
            <div className="p-4 overview-content">
                <OverviewHeader assetId={softwareData.id} />
            </div>
        );
    }

    const overview = overviewQuery.data;
    const degraded = overview.meta?.degraded || [];

    return (
        <div className="p-4 overview-content">
            <Row>
                <Col sm="12" className="mb-4">
                    <OverviewHeader assetId={softwareData.id} />
                </Col>
                <Col sm="12">
                    <AiSummary
                        softwareData={softwareData}
                        core={overview.core}
                        ai={overview.ai}
                        assessments={overview.assessments}
                        degraded={degraded.includes("ai")}
                    />
                </Col>
                <Col sm="12">
                    <OverviewApprovals
                        softwareData={softwareData}
                        approvals={overview.approvals}
                    />
                </Col>
                <Col sm="12" className="mb-4">
                    <Row className="g-3">
                        <Col xs="12" lg="6">
                            <DocumentationChangeTrend
                                trend={overview.documentation?.trend}
                            />
                        </Col>
                        <Col xs="12" lg="6">
                            <DocumentationGap
                                softwareId={softwareData?.id}
                                gap={overview.documentation?.gap}
                                lastUpdate={
                                    overview.documentation?.trend?.period?.to
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col sm="12">
                    <NextSteps
                        softwareId={softwareData.id}
                        recommendedActions={overview.recommendedActions}
                    />
                </Col>
                <Col sm="12" className="mb-4">
                    <Row className="g-3">
                        <Col xs="12" lg="6">
                            <DataFlowCard
                                softwareData={softwareData}
                                dataFlow={overview.dataFlow}
                                degraded={degraded.includes("dataFlow")}
                            />
                        </Col>
                        <Col xs="12" lg="6">
                            <RisksCreatedChart
                                risk={overview.risk || overview.risks}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col xs="12" lg="6">
                    <RecentActivity
                        recentActivity={overview.recentActivity}
                        degraded={degraded.includes("recentActivity")}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default withNamespaces()(Overview);
